'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SystemMetricsService = function () {
  function SystemMetricsService($http) {
    'ngInject';

    _classCallCheck(this, SystemMetricsService);

    Object.assign(this, {
      $http: $http
    });
  }

  _createClass(SystemMetricsService, [{
    key: 'getReport',
    value: function getReport(params) {
      return this.$http.get('/api/report/data_m_y_admin', {
        params: _extends({}, params)
      }).then(function (r) {
        return r.data;
      });
    }
  }]);

  return SystemMetricsService;
}();

exports.default = SystemMetricsService;


// WEBPACK FOOTER //
// ./components/app/reports/system-metrics/system-metrics.service.js